import React from 'react';
import { observer } from 'mobx-react-lite';
import { SubMenuItemFiltersPropsType } from 'src/domains/casino/webview/bonus-engine/campaign-list/filters/filters.type';
import { SubMenuItemWrapper } from 'src/domains/common/components/menu-bar/menu-bar';

export const SubMenuItemFilters = observer(
    ({ item, label, campaignListState }: SubMenuItemFiltersPropsType): JSX.Element => {
        const handleClick = (): void => {
            switch (label) {
                case 'Campaign':
                    return campaignListState.toggleSelectedCampaign?.(item.key);
                case 'Reward':
                    return campaignListState.toggleSelectedReward(item.key);
                case 'Status':
                    return campaignListState.toggleSelectedStatus(item.key);
                case 'Player Type':
                    return campaignListState.toggleSelectedPlayerType?.(item.key);
                case 'Opt In':
                    return campaignListState.toggleSelectedOptIn?.(item.key);
                case 'Has Promo Code':
                    return campaignListState.toggleSelectedHasPromoCode?.(item.key);
                case 'Action':
                    return campaignListState.toggleSelectedAction?.(item.key);
                case 'Source':
                    return campaignListState.toggleSelectedSource?.(item.key);
                default:
                    break;
            }
        };

        let isSelected = false;
        switch (label) {
            case 'Campaign':
                isSelected = campaignListState.selectedCampaignsSet?.has(item.key) ?? false;
                break;
            case 'Reward':
                isSelected = campaignListState.selectedRewards.includes(item.key);
                break;
            case 'Status':
                isSelected = campaignListState.selectedStatuses.includes(item.key);
                break;
            case 'Player Type':
                isSelected = campaignListState.selectedPlayerType?.includes(item.key) ?? false;
                break;
            case 'Opt In':
                isSelected = campaignListState.selectedOptIn?.includes(item.key) ?? false;
                break;
            case 'Has Promo Code':
                isSelected = campaignListState.selectedHasPromoCode?.includes(item.key) ?? false;
                break;
            case 'Action':
                isSelected = campaignListState.selectedAction?.includes(item.key) ?? false;
                break;
            case 'Source':
                isSelected = campaignListState.selectedSources?.includes(item.key) ?? false;
                break;
        }

        return (
            <SubMenuItemWrapper
                label={item.label}
                onClick={handleClick}
                isSelected={isSelected}
                data-test={`filter-item-${item.key}`}
            />
        );
    }
);
